import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import axios from 'axios';
import Pagination from 'react-js-pagination';
import { formatDate } from "../../utils/format_date";
import { formatWon } from "../../utils/format_amount";

// '더보기' 팝업에서 사용할 테이블 행/열 컴포넌트 (가정)
import CommonTable from "../../component/table_list/common_table";
import CommonTableRow from "../../component/table_list/common_tablerow";
import CommonTableColumn from "../../component/table_list/common_tablecolumn";

// 모달 스타일 정의
const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
`;

const ModalContent = styled.div`
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    width: 80%;
    max-width: 900px;
    max-height: 80%;
    overflow: hidden; /* 내부 스크롤을 div로 처리 */
    position: relative;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
`;

const ModalHeader = styled.div`
    font-size: 1.5rem;
    font-weight: bold;
    margin-bottom: 20px;
    border-bottom: 2px solid #333;
    padding-bottom: 10px;
    display: flex;
    justify-content: center; /* ✅ 중앙 정렬 */
    align-items: center;
    color: #337ab7;
`;

const PaginationBox = styled.div`
  .pagination { display: flex; justify-content: center; margin-top: 15px;}
  ul { list-style: none; padding: 0; }
  ul.pagination li {
    display: inline-block;
    width: 35px; /* ✅ 크기 확대 */
    height: 35px; /* ✅ 크기 확대 */
    border: 1px solid #e2e2e2;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.2rem; /* ✅ 폰트 크기 확대 */
  }
  ul.pagination li:first-child{ border-radius: 5px 0 0 5px; }
  ul.pagination li:last-child{ border-radius: 0 5px 5px 0; }
  ul.pagination li a { text-decoration: none; color: #337ab7; font-size: 1.2rem; } /* ✅ 폰트 크기 확대 */
  ul.pagination li.active a { color: white; }
  ul.pagination li.active { background-color: #337ab7; }
  ul.pagination li a:hover,
  ul.pagination li a.active { color: blue; }
`;

const BaseButton = styled.button`
    padding: 8px 18px; 
    border-radius: 8px; 
    font-weight: 600;
    cursor: pointer; 
    transition: all 0.2s; 
    border: none; 
    font-size: 0.9rem;
`;

const OutlineButton = styled(BaseButton)`
    background-color: white; 
    border: 1px solid #ccc; 
    color: #555;
    &:hover { background-color: #f9f9f9; border-color: #bbb; }
`;


function UserReserveModal({ userId, onClose, onWithdrawSuccess }) {
    // ✅ API에서 모든 데이터를 받을 상태
    const [allReserveList, setAllReserveList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const itemsPerPage = 8;

    // Image Modal State
    const [imagePath, setImagePath] = useState('');
    const [isImageModalOpen, setIsImageModalOpen] = useState(false);

    // ✅ 모든 예약 내역을 불러오는 함수 (API 적용)
    const fetchUserReservations = async () => {
        setLoading(true);
        try {
            // ✅ 수정: HistoryAll 엔드포인트 호출 (페이징 없이 모든 데이터 요청)
            const result = await axios.get(`/Reservation/HistoryAll/${userId}`);

            const allReservations = result.data.reservations || [];

            // 모든 데이터를 상태에 저장 (클라이언트 페이징 준비)
            setAllReserveList(allReservations);

        } catch (error) {
            console.error(`Error fetching reservations for user ${userId}:`, error.message);
            setAllReserveList([]);
        } finally {
            setLoading(false);
        }
    };

    // ✅ 데이터는 한 번만 로드하고, 페이지네이션 변경 시 다시 로드하지 않음
    useEffect(() => {
        if (userId) {
            fetchUserReservations();
        }
    }, [userId]);

    const hadlePageChange = (currentPage) => {
        setPage(currentPage);
    };

    const showImage = async (reqNumber) => {
        try {
            const response = await axios.get(`/image/user/reservation/${userId}/${reqNumber}`, {
                responseType: 'blob'
            });
            const imageUrl = URL.createObjectURL(response.data);
            setImagePath(imageUrl);
            setIsImageModalOpen(true);
        } catch (error) {
            console.error('Error fetching image:', error.message);
            alert("첨부된 이미지를 불러올 수 없습니다.");
        }
    };

    const handleWithdraw = async () => {
        try {
            // 1. 진행중 예약 사전 체크
            const checkRes = await axios.get(`/Reservation/ING/${userId}`);
            const ingReservations = checkRes.data.reservations || [];
            if (ingReservations.length > 0) {
                alert(`진행중인 예약건이 ${ingReservations.length}건 있습니다. 예약 완료 또는 취소 후 탈퇴가 가능합니다.`);
                return;
            }
        } catch (error) {
            console.error('Error checking reservations:', error);
            alert('예약 상태 확인 중 오류가 발생했습니다.');
            return;
        }

        // 2. 진행중 예약 없으면 기존 confirm → DELETE 흐름
        if (window.confirm('정말로 탈퇴 처리하시겠습니까?')) {
            try {
                const response = await axios.delete(`/Admin/UserRegist/${userId}`);
                if (response.data.success) {
                    alert('회원 탈퇴 처리가 완료되었습니다.');
                    if (onWithdrawSuccess) onWithdrawSuccess();
                    else onClose();
                } else {
                    alert(response.data.message || '탈퇴 처리에 실패했습니다.');
                }
            } catch (error) {
                console.error('Error withdrawing user:', error);
                const errMsg = error.response?.data?.message || '탈퇴 처리 중 오류가 발생했습니다.';
                alert(errMsg);
            }
        }
    };

    // ✅ 클라이언트 측 페이지네이션 계산
    const paginatedList = allReserveList.slice((page - 1) * itemsPerPage, page * itemsPerPage);
    const totalCount = allReserveList.length;

    if (loading) {
        return (
            <ModalOverlay onClick={onClose}>
                <ModalContent onClick={e => e.stopPropagation()}>
                    <div style={{ textAlign: 'center', padding: '50px' }}>데이터 로딩 중...</div>
                </ModalContent>
            </ModalOverlay>
        );
    }

    return (
        <>
            <ModalOverlay onClick={onClose}>
                <ModalContent onClick={e => e.stopPropagation()}>

                    {/* 헤더 영역 */}
                    <div style={{ position: 'relative', marginBottom: '10px' }}>
                        {/* ✅ 우측 상단 고객 ID 표시 */}
                        <div style={{
                            position: 'absolute',
                            top: '-15px', /* Header padding 고려하여 위치 조정 */
                            right: '0px',
                            fontSize: '0.9rem',
                            color: '#888'
                        }}>
                            ID: {userId}
                        </div>

                        {/* ✅ 중앙 정렬된 "더보기" 제목 */}
                        <ModalHeader>
                            더보기
                        </ModalHeader>
                    </div>

                    {/* 테이블 내용 영역 (스크롤 처리) */}
                    <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                        <CommonTable headerTitle={['No', '오더번호', '에어컨 종류', '수량', '금액', '담당매니저', '첨부파일']}>
                            {paginatedList.length > 0 ? (
                                paginatedList.map((reserve, index) => (
                                    <CommonTableRow key={reserve.req_number} idx={reserve.idx}>
                                        <CommonTableColumn>{((page - 1) * itemsPerPage) + index + 1}</CommonTableColumn>
                                        <CommonTableColumn>{reserve.req_number}</CommonTableColumn>
                                        <CommonTableColumn>{reserve.working_kind || '-'}</CommonTableColumn> {/* working_kind 사용 */}
                                        <CommonTableColumn>{reserve.work_count || 0}</CommonTableColumn>   {/* work_count 사용 */}
                                        <CommonTableColumn>{formatWon(reserve.amount)}</CommonTableColumn>
                                        <CommonTableColumn>{reserve.mg_name || '미배정'}</CommonTableColumn>
                                        <CommonTableColumn>
                                            <button
                                                style={{ padding: '4px 8px', border: '1px solid #ccc', borderRadius: '3px', cursor: 'pointer' }}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    showImage(reserve.req_number);
                                                }}
                                            >
                                                사진보기
                                            </button>
                                        </CommonTableColumn>
                                    </CommonTableRow>
                                ))
                            ) : (
                                <CommonTableRow>
                                    {/* ✅ 예약 내역 없을 시 중앙 정렬 (요청 반영) */}
                                    <CommonTableColumn colSpan={7} style={{ textAlign: 'center', padding: '20px 0', fontWeight: 'bold' }}>
                                        예약 내역이 없습니다.
                                    </CommonTableColumn>
                                </CommonTableRow>
                            )}
                        </CommonTable>
                    </div>

                    {/* 페이지네이션 및 닫기 버튼 영역 */}
                    <PaginationBox style={{ marginTop: '20px' }}>
                        <Pagination
                            activePage={page}
                            itemsCountPerPage={itemsPerPage}
                            totalItemsCount={totalCount}
                            pageRangeDisplayed={10}
                            onChange={hadlePageChange}>
                        </Pagination>
                    </PaginationBox>

                    <div style={{ textAlign: 'center', marginTop: '10px', display: 'flex', justifyContent: 'center', gap: '10px' }}>
                        <OutlineButton onClick={onClose}>닫기</OutlineButton>
                    </div>
                </ModalContent>
            </ModalOverlay>

            {/* Image Modal */}
            {isImageModalOpen && (
                <ModalOverlay onClick={() => setIsImageModalOpen(false)} style={{ zIndex: 1100 }}>
                    <ModalContent onClick={e => e.stopPropagation()} style={{ width: 'auto', maxWidth: '90%', maxHeight: '90%', display: 'flex', flexDirection: 'column' }}>
                        <div style={{ position: 'relative', marginBottom: '10px', textAlign: 'center' }}>
                            <ModalHeader>첨부 사진</ModalHeader>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'center', flex: 1, overflow: 'hidden' }}>
                            <img src={imagePath} alt="Reservation Attachment" style={{ maxWidth: '100%', maxHeight: '60vh', objectFit: 'contain' }} />
                        </div>
                        <div style={{ textAlign: 'center', marginTop: '20px' }}>
                            <button style={{ padding: '8px 15px', cursor: 'pointer', background: '#337ab7', color: 'white', border: 'none', borderRadius: '4px' }} onClick={() => setIsImageModalOpen(false)}>닫기</button>
                        </div>
                    </ModalContent>
                </ModalOverlay>
            )}
        </>
    );
}

export default UserReserveModal;
